// extracted by mini-css-extract-plugin
module.exports = {"selectionCounter":"Selection_selectionCounter__HKYwV"};